<h4 class="text-center">Push Back</h4>

@if(gettingData() === true)
{
  <div class="loading-display" >
    <app-lt-spinner></app-lt-spinner>
  </div>
}
@else
{
  @if (integrationRunTimes && integrationRunTimes.length === 0)
  {
    <div class="inline">
      <h1 class="text-center">No Run Times</h1>
    </div>
  }

  @if((addingIntegrationPushBack === true || editingIntegrationPushBack === true) && checkAccess(['LOSTalker.Admin']))
  {
    <div class="w-50">
      <app-integration-pushback-add 
        [integrationRunTimes]="integrationRunTimes"
        [integration]="integration"
        [updatingItem]="selectedPushBack"
        [showBackButton]="true"
        (itemAdded)="integrationPushBackAdded($event)"
        (itemUpdated)="integrationPushBackUpdated($event)"
        (cancel)="integrationPushBackCancelAdded()"></app-integration-pushback-add>
    </div>
  }
  @else if (integrationRunTimes && integrationRunTimes.length > 0 && integrationPushBacks)
  {

    @if (checkAccess(['LOSTalker.Admin']) && hasActivePushBacks() === false)
    {
      <button matButton="outlined" class="inline add-pushback-btn mb-2"
        (click)="setAddingIntegrationPushBack()"
        [disabled]="savingIntegrationRuntime">
          Add Push Back
      </button>
    }

    <app-integration-pushback-view #pushBackView
      [integrationPushBacks]="integrationPushBacks"
      [integrationRunTimes]="integrationRunTimes"
      [integration]="integration"
      [integrations]="integrations"
      [hideIntegrationColumns]="true"
      (itemToDelete)="setDeletingIntegrationRunTime($event)"
      (itemToEdit)="setEditingIntegrationRunTime($event)"
      [allowDelete]="checkAccess('Admin')"></app-integration-pushback-view>
  }
}



<ng-template #deletePushBackDialog>
  <h2 matDialogTitle>Confirm Deleting PushBack</h2>
  <mat-dialog-content>
    <span>The PushBack for {{selectedRunTime.importTypeDescription}} - {{selectedRunTime.destinationEndpointName}} RunTime will be deleted.</span>
    <br/>
    <span>TriggerDate: {{selectedPushBack.triggerDate | date :'MM/dd/yyyy h:mm a'}}</span>
    <br/>
    <span>LastRunTime: {{selectedPushBack.pushBackLastRunTimeDate | date :'MM/dd/yyyy h:mm a'}}</span>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton [disabled]="savingIntegrationPushBack" (click)="deleteIntegrationPushBack()">Delete</button>
    <button matButton [disabled]="savingIntegrationPushBack" matDialogClose>Cancel</button>
  </mat-dialog-actions>
</ng-template>